"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.benefitInputSchema = exports.promotionCodeResponseSchema = exports.promotionCodeSchema = exports.promotionCodeInputSchema = exports.goldTrialResultCode = void 0;
var zod_1 = require("zod");
exports.goldTrialResultCode = {
    SUCCESS: 'SUCCESS',
    ALREADY_TRIAL: 'ALREADY_TRIAL',
    ALREADY_GOLD: 'ALREADY_GOLD',
};
exports.promotionCodeInputSchema = zod_1.z.object({
    redeemCode: zod_1.z.string().min(1).max(16),
});
exports.promotionCodeSchema = zod_1.z.object({
    benefitType: zod_1.z.union([
        zod_1.z.literal('COUPON'),
        zod_1.z.literal('POINT'),
        zod_1.z.literal('B2B_POINT_SALES'),
        zod_1.z.literal('NOL_POINT'),
        zod_1.z.literal('NOL_POINT_SALES'),
    ]),
    benefitTitle: zod_1.z.union([zod_1.z.number(), zod_1.z.string()]),
    /** (LGU+ 너겟 코드 한정) 체험등급 승격 결과 */
    goldTrialResult: zod_1.z.nativeEnum(exports.goldTrialResultCode).nullish(),
    /** (LGU+ 너겟 코드 한정) 골드 체험 일수 */
    goldTrialDays: zod_1.z.number().nullish(),
    calculateValue: zod_1.z.number().nullish(),
});
exports.promotionCodeResponseSchema = zod_1.z.object({
    result: zod_1.z.string(),
});
exports.benefitInputSchema = zod_1.z.object({
    cipherText: zod_1.z.string(),
});
